import React, { FC } from 'react'
import { Theme, makeStyles } from '@material-ui/core'
import { AboutModal } from 'components'
import { Modal } from 'components/shared/modal'

interface AboutEventModalProps {
  onClose: () => void
  open: boolean
}

export const AboutEventModal: FC<AboutEventModalProps> = ({ open, onClose }) => {
  const classes = useStyles()

  return (
    <Modal onClose={onClose} closeFn={onClose} open={open} className={classes.modal}>
      <AboutModal />
    </Modal>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  modal: {
    alignItems: 'unset !important',
    margin: '4vh auto 0',
    maxHeight: '96vh',
    minWidth: '60%',
    maxWidth: '1100px',
    [theme.breakpoints.down('sm')]: {
      margin: 0,
      maxWidth: '100vw',
      '& > div': {
        width: '100vw'
      }
    }
  }
}))
